import { connect } from 'react-redux'
import { DraggingHint } from 'aria-viewer/common'
import { draggingHintMounted } from '../actions/videoActions'
import withLifeCycle from 'recompose/lifecycle'
import compose from 'recompose/compose'

const mapStateToProps = state => ({
    isVisible: state.getIn(['video', 'draggingHint', 'isVisible']),
    delay: state.getIn(['video', 'draggingHint', 'delay']),
    showAnimation: state.getIn(['device', 'isDeviceDesktop']),
})

const mapDispatchToProps = dispatch => ({
    draggingHintMounted: _ => {
        dispatch(draggingHintMounted())
    },
})

const lifeCycle = withLifeCycle({
    componentDidMount: function() {
        const { draggingHintMounted } = this.props
        draggingHintMounted()
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    lifeCycle
)(DraggingHint)
